import { ThemeProvider, createTheme } from "@mui/material/styles"
import CssBaseline from "@mui/material/CssBaseline"
import LoginPage from "./components/LoginPage"
import Dashboard from "./components/Dashboard"
import { AppProvider } from "./contexts/AppContext"
import { useApp } from "./contexts/AppContext"

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
})

export default function App() {
  return (
    <AppProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppContent />
      </ThemeProvider>
    </AppProvider>
  )
}

const AppContent = () => {
  const { state, actions } = useApp()

  return (
    <>
      {!state.isAuthenticated ? (
        <LoginPage onLogin={actions.login} />
      ) : (
        <Dashboard user={state.user} onLogout={actions.logout} />
      )}
    </>
  )
}
